import {
  mapApiResourceToTokens,
  type AuthenticationTokens,
  type TokenPairApiResource,
} from '@/api/auth/authApi.types';
import {
  mapApiResourceToInvitation,
  type Invitation,
  type InvitationApiResource,
} from '@/api/invitations/invitationsApi.types';
import {
  mapApiResourceToTenant,
  type Tenant,
  type TenantApiResource,
} from '@/api/tenants/tenantsApi.types';
import {
  mapApiResourceToUser,
  type PlatformUser,
  type UserApiResource,
} from '@/api/users/usersApi.types';

export type WorkspaceType = 'solo' | 'organization';

export interface RegisterWorkspacePayload {
  tenantType: WorkspaceType;
  workspaceName: string;
  organizationName: string | null;
  fullName: string;
  email: string;
  password: string;
  phone: string | null;
  preferredLanguage: string;
  acceptTerms: boolean;
}

export interface WorkspaceRegistrationApiResource {
  user: UserApiResource;
  tenant: TenantApiResource;
  tokens: TokenPairApiResource;
}

export interface WorkspaceRegistration {
  user: PlatformUser;
  tenant: Tenant;
  tokens: AuthenticationTokens;
}

export interface CreateAdminWorkspacePayload {
  tenantType: WorkspaceType;
  name: string;
  businessName: string | null;
  defaultLanguage: string;
  ownerFullName: string | null;
  ownerEmail: string;
}

export interface AdminWorkspaceCreationApiResource {
  tenant: TenantApiResource;
  invitation: InvitationApiResource;
  invite_link: string;
}

export interface AdminWorkspaceCreation {
  tenant: Tenant;
  invitation: Invitation;
  inviteLink: string;
}

export function mapApiResourceToWorkspaceRegistration(
  resource: WorkspaceRegistrationApiResource
): WorkspaceRegistration {
  return {
    user: mapApiResourceToUser(resource.user),
    tenant: mapApiResourceToTenant(resource.tenant),
    tokens: mapApiResourceToTokens(resource.tokens),
  };
}

export function mapApiResourceToAdminWorkspaceCreation(
  resource: AdminWorkspaceCreationApiResource
): AdminWorkspaceCreation {
  return {
    tenant: mapApiResourceToTenant(resource.tenant),
    invitation: mapApiResourceToInvitation(resource.invitation),
    inviteLink: resource.invite_link,
  };
}
